"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = exports.HelpaApi = void 0;
// Export the main HelpaApi class
var client_1 = require("./client");
Object.defineProperty(exports, "HelpaApi", { enumerable: true, get: function () { return client_1.HelpaApi; } });
// Export types
__exportStar(require("./types"), exports);
// Re-export AxiosError as ApiError for consumers
var axios_1 = require("axios");
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return axios_1.AxiosError; } });
//# sourceMappingURL=index.js.map